import { RollupType } from 'pages/raas/helpers/labels';
import { useRaasDeployment, useRaasMetrics } from 'pages/raas/hooks';
import { useParams } from 'react-router-dom';
import { Metric } from 'shared/components/metric';
import { Panel } from 'shared/types/protoc-gen/raas-metrics';

import { useDateRangeFilterOptions } from '../../hooks/useDateRangeFilterOptions';
import { DateFilterVariant } from '../../store';

interface MemoryMetricProps {
  instance?: string;
}

export const MemoryMetric = ({ instance }: MemoryMetricProps) => {
  const { rollupId } = useParams();
  const { data: rollup } = useRaasDeployment();

  const { end, start, step, timeframe } = useDateRangeFilterOptions(
    DateFilterVariant.BLOCKCHAIN_STATS_GENERAL_SECTION,
  );

  const getPanel = () => {
    switch (rollup?.type) {
      case RollupType.ORBIT:
        return Panel.PANEL_ORBIT_MEMORY;
      case RollupType.OPSTACK:
      default:
        return Panel.PANEL_OPSTACK_MEMORY;
    }
  };

  const { data: result, isPending } = useRaasMetrics({
    panel: getPanel(),
    timeframe,
    rollupId,
    start,
    end,
    step,
    podInstance: instance,
  });

  return (
    <Metric
      chartType="line"
      data={result}
      description={'Memory usage of each node over time'}
      hideLegend={false}
      id={'memory'}
      legendDirection={'column'}
      legendSpacing={'4px'}
      loading={isPending}
      title={'Memory'}
      yAxisProps={{
        tickFormatter: value => [new Intl.NumberFormat().format(value), 'GB'].join(' '),
      }}
    />
  );
};
